<template>
  <v-row>
    <v-col cols="12" md="6" offset-md="3">
      <form @submit.prevent="save">
        <v-text-field
          v-model="form.name"
          label="Ime *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.name.required)"
        >
          <FormErrorsLine v-if="!$v.form.name.required" text="Polje je obvezno" />
        </FormErrors>
        <v-row>
          <v-col>
            <v-text-field
              v-model="form.color"
              label="Barva *"
              :disabled="true"
            ></v-text-field>
            <FormErrors
              v-if="$v.form.$error && (!$v.form.color.required)"
            >
              <FormErrorsLine v-if="!$v.form.color.required" text="Polje je obvezno" />
            </FormErrors>
          </v-col>
          <v-col>
            <ColorPicker v-model="color" />
          </v-col>
        </v-row>
        <v-checkbox
          color="#0F998E"
          v-model="form.is_visible"
          label="Je viden"
        ></v-checkbox>
        <v-btn type="submit" class="float-right">Shrani</v-btn>
        <v-btn v-if="isNewLevel" type="button" class="float-right mr-4" @click="saveAndRepeat">Shrani in nov</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="$router.go(-1)">Prekliči</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import ColorPicker from '@/components/ColorPicker'

export default {
  components: {
    FormErrors,
    FormErrorsLine,
    ColorPicker
  },
  props: {
    level: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      color: '#000000',
      emptyForm: {
        name: null,
        color: '#000000',
        is_visible: true
      },
      form: {}
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      color: {
        required
      }
    }
  },
  computed: {
    isNewLevel () {
      return this.level ? Object.keys(this.level).length === 0 : true
    }
  },
  methods: {
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    saveAndRepeat () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form, repeat: true })
      }
    },
    clearForm () {
      this.form = { ...this.emptyForm }
      this.color = '#000000'
      this.$v.$reset()
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  created () {
    this.form = { ...this.emptyForm }
    if (!this.isNewLevel) {
      this.form = { ...this.form, ...this.level }
      this.color = this.level.color
    }
  },
  watch: {
    color (color) {
      this.form.color = color
    }
  }
}
</script>
